
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBlowerStaticVertical as ObiBlowerStaticVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-blower-static-vertical.js';
 
 
 

 
 export const ObiBlowerStaticVertical = createComponent({
   react: React,
   tagName: 'obi-blower-static-vertical',
   elementClass: ObiBlowerStaticVerticalElement,
   events: {
     
   }
  });
 
 